import React from "react"
import { StaticBackdropControlPanelProps } from "../types/modal"
import { Button } from "react-bootstrap"

export const StaticBackdropControlPanel = (props: StaticBackdropControlPanelProps) => {
    return (
        <div className="row ui-has-modules">
            <div className="col-12 ui-module">
                <div className="row p-3">
                    <div className="col-12 d-flex justify-content-between">
                        <div/>

                        <Button
                            className={"col-3"}
                            variant="primary"
                            onClick={props.onClickCallback}>
                            {props.btnText}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/common/modal/StaticBackdropControlPanel.tsx